import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import user from "./modules/user";
import notice from "./modules/notice";
import newYearScroll from "./modules/newYearScroll";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
let store;
try {
    store = new Vuex.Store({
        plugins: window.Storage && window.localStorage && window.localStorage instanceof Storage ? [
            createPersistedState({
                key: "basion-vuex",
                paths: ["app.appInfo", "user.userInfo", "notice"],
            }),
        ] : [],
        modules: {
            app,
            user,
            notice,
            newYearScroll,
        },
    });
}
catch (e) {
    store = new Vuex.Store({
        plugins: [],
        modules: {
            app,
            user,
            notice,
            newYearScroll,
        },
    });
}


export default store;